import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "./sentry";
import { bootstrapTelegram } from "./lib/telegram";
import { App } from "./App";
import "./styles.css";

initSentry();
const { startParam } = bootstrapTelegram();

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");

createRoot(root).render(
  <StrictMode>
    <App {...(startParam ? { startParam } : {})} />
  </StrictMode>,
);
